import { apiClient } from "../config";

async function archiveOrRestoreObject(id: any, status: any) {
  const url = `/admin/objects/${id}/archive`;
  const res = await apiClient.put(url, null, { params: { status } });
  return res.data;
}

export default archiveOrRestoreObject;
